import React from 'react';
import { CONTENT } from '../../Pages';

export default {
  path: CONTENT.pageURL,
  async action() {
    const { default: ContentManager } = await import('./ContentManager');
    return <ContentManager key={'list'} />;
  },
};
